import { LicenseStatus, LicenseType } from '@trip-ux/constants';
import { License, LicenseSearchResult } from './types';

const licenseStatusMap = {
  [LicenseStatus.AUTHORIZED]: 'Authorized',
  [LicenseStatus.IN_PROGRESS]: 'In Progress',
  [LicenseStatus.NOT_AUTHORIZED]: 'Not Authorized',
  [LicenseStatus.RENEWAL_PENDING]: 'Renewal Pending',
  deleted: 'Deleted'
};

const licenseTypeMap = {
  [LicenseType.AGENCY]: 'Agency',
  [LicenseType.AGENT]: 'Agent'
};

export const formatLicenseSearchResponse = (
  licenses: LicenseSearchResult[]
): (Partial<License> | Record<string, string | number | boolean>)[] => {
  return licenses.map(license => ({
    id: license.id,
    name: license.name,
    status: license.isDeleted ?licenseStatusMap.deleted :licenseStatusMap[license.status],
    licensedProvince: license.licensedProvince,
    organizationCode: license.organizationCode,
    licenseType: license.profileRef ? licenseTypeMap[LicenseType.AGENT] : licenseTypeMap[LicenseType.AGENCY],
    licenseNumber: license.licenseNumber,
    isDeleted: license.isDeleted,
    profileRef: license.profileRef
  }));
};
